// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"356c76c3f73def628080","6980":"e2a6c4d1730ee0465b47"}[chunkId] + ".js";
};